<template>
  <split-pane :min-percent="20" :default-percent="50" split="vertical">
    <template slot="paneL" v-if="!isShowPic">
      <a-card title="提醒列表">
        <!--          <a slot="extra">-->
        <!--            <a-tooltip title="提醒逻辑：1.本期平均值 低于 往期平均值 * ( 1 - 阈值% )。2.计算逻辑：先取个人单日情绪值再取所有学生平均值。3.去除周期内超一半日期无抓拍数据学生，去除双休日法定节假日数据。4.时间跨度须以周为单位较为精准，周一开始，周日结束。">-->
        <!--              <a-icon type="info-circle" style="cursor: pointer;"/>-->
        <!--            </a-tooltip>-->
        <!--          </a>-->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :span="8" v-if="userInfo().username !== 'admin'">
                <a-form-item label="关爱等级">
                  <j-dict-select-tag
                    v-model="queryParam.threshold"
                    placeholder="请选择关爱等级"
                    dictCode="warn_level"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="8" v-else>
                <a-form-item label="情绪阈值">
                  <a-input-number v-model="queryParam.threshold" :min="0" :max="100" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item label="时间范围">
                  <a-range-picker :value="rangeDate" @change="onRangeChange" />
                </a-form-item>
              </a-col>

              <a-col :span="4">
                <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="loadData" icon="search">查询</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button type="primary" icon="download" @click="handleExportXls('学生提醒数据分析')">
            导出
          </a-button>
        </div>

        <div>
          <a-table
            ref="table"
            size="middle"
            :scroll="{ x: 'auto', y: 550 }"
            bordered
            rowKey="id"
            :columns="columnsWithOutHidden"
            :dataSource="dataSource"
            :loading="loading"
            :pagination="false"
            @change="handleTableChange"
          >
            <a
              slot="studentName"
              :style="text === currentStudentName ? 'color:red' : ''"
              slot-scope="text, record"
              @click="changeSelect(record)"
            >
              {{ text }}
            </a>
          </a-table>
        </div>
      </a-card>
    </template>
    <template slot="paneL" v-else>
      <a-card title="照片清单">
        <a-spin tip="加载中..." :spinning="picLoading">
          <a-timeline style="overflow-y: auto; height: 700px">
            <a-timeline-item color="green" v-for="(item, index) in this.picData" :key="index">
              <p>{{ item.name }}</p>
              <div>
                <div
                  style="width: 100px; display: inline-block"
                  v-for="(pic, uIndex) in item.data"
                  :key="uIndex"
                >
                  <img
                    style="width: 100px; height: 100px; border: 1px solid #ccc; padding: 5px"
                    :src="getImgView(pic.faceUrl)"
                  />
                  <div v-if="userInfo().username === 'admin'" style="text-align: center">
                    {{ pic.emotion_dictText }}
                  </div>
                </div>
              </div>
            </a-timeline-item>
          </a-timeline>
        </a-spin>
      </a-card>
    </template>
    <template slot="paneR">
      <a-card title="分析模型">
        <a-button
          v-has="'studentPic:show'"
          v-show="currentStudentName !== ''"
          type="primary"
          slot="extra"
          @click="showPic"
        >
          {{ isShowPic ? '返回' : '查看照片' }}
        </a-button>
        <a-spin tip="加载中..." :spinning="chartLoading">
          <smooth-line-chart-multid
            :height="187"
            :title="currentStudentName + '【本期与往期情绪趋势】'"
            :fields="['本期', '往期']"
            :dataSource="selfData"
          />
          <smooth-line-chart-multid
            :height="187"
            :title="currentStudentName + '【本期与班级情绪趋势】'"
            :fields="['个人', '班级']"
            :dataSource="classData"
          />
          <smooth-line-chart-multid
            :height="187"
            :title="currentStudentName + '【本期与年级情绪趋势】'"
            :fields="['个人', '年级']"
            :dataSource="gradeData"
          />
          <smooth-line-chart-multid
            :height="187"
            :title="currentStudentName + '【近8周提醒趋势】'"
            :fields="['提醒趋势']"
            :dataSource="warnData"
          />
        </a-spin>
      </a-card>
    </template>
  </split-pane>
</template>

<script>
import splitPane from 'vue-splitpane'
import '@/assets/less/TableExpand.less'
import { getAction } from '@api/manage'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SmoothLineChartMultid from '@/components/chart/SmoothLineChartMultid'
import moment from 'moment'
import { mapGetters } from 'vuex'
import UpdateStudentFaceModal from '../studentInfo/modules/UpdateStudentFaceModal'

export default {
  name: 'StudentWarn',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    splitPane,
    SmoothLineChartMultid,
    UpdateStudentFaceModal,
  },
  data() {
    return {
      loading: false,
      queryParam: {
        threshold: 20,
      },
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '班级',
          align: 'center',
          dataIndex: 'className',
          width: 100,
          ellipsis: true,
        },
        {
          title: '学生',
          align: 'center',
          dataIndex: 'studentName',
          scopedSlots: { customRender: 'studentName' },
          width: 80,
        },
        {
          title: '情绪指数',
          align: 'center',
          children: [
            {
              title: '学生(本期)',
              align: 'center',
              dataIndex: 'personHappyRate',
              width: 60,
            },
            {
              title: '学生(往期)',
              align: 'center',
              dataIndex: 'historyHappyRate',
              width: 60,
            },
            {
              title: '班级(本期)',
              align: 'center',
              dataIndex: 'classHappyRate',
              width: 60,
            },
            {
              title: '年级(本期)',
              align: 'center',
              dataIndex: 'gradeHappyRate',
              width: 60,
            },
          ],
        },
        {
          title: '关爱名单',
          align: 'center',
          dataIndex: 'careList',
          width: 80,
          filters: [
            { text: '须关爱', value: 1 },
            { text: '正常', value: 0 },
          ],
          onFilter: (value, record) => record.careList === value,
          customRender: function (t, r, index) {
            return t === 0 ? '否' : '是'
          },
        },
        // {
        //   title: '家长访问(次)',
        //   align: "center",
        //   dataIndex: 'visitCnt'
        // }
      ],
      columnsWithOutHidden: [],
      chartLoading: false,
      selfData: [],
      classData: [],
      gradeData: [],
      warnData: [],
      currentStudentId: '',
      currentStudentName: '',
      isShowPic: false,
      rangeDate: [],
      picLoading: false,
      picData: [],
      url: {
        list: '/statistic/studentWarn',
        studentWarnAnalysis: '/statistic/studentWarnAnalysis',
        studentFaceList: '/aigoes/studentFace/list',
        exportXlsUrl: '/aigoes/statisticStudentWarn/exportXls',
      },
    }
  },
  created() {
    this.columnsWithOutHidden = this.columns.filter((item) => !item.hidden)
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')

    this.loadData()
  },
  methods: {
    ...mapGetters(['userInfo']),
    loadData() {
      this.loading = true
      this.selfData = []
      this.classData = []
      this.gradeData = []
      this.warnData = []
      getAction(this.url.list, this.queryParam).then((res) => {
        if (res.success) {
          this.dataSource = res.result
        }
        if (res.code === 500) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    changeSelect(record) {
      console.log(record)
      this.currentStudentId = record.studentId
      this.currentStudentName = record.studentName
      this.loadChartData(record.studentId)
    },
    loadChartData(studentId) {
      this.chartLoading = true
      this.queryParam.studentId = studentId
      getAction(this.url.studentWarnAnalysis, this.queryParam).then((res) => {
        if (res.success) {
          this.selfData = res.result.warnStudentBySelf
          this.classData = res.result.warnStudentByClass
          this.gradeData = res.result.warnStudentByGrade
          this.warnData = res.result.warnTrend
        }
        this.chartLoading = false
      })
    },

    onRangeChange(dates, dateString) {
      this.rangeDate = dates

      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]

      this.loadData()
    },
    showPic() {
      this.picLoading = true
      this.isShowPic = !this.isShowPic
      if (this.isShowPic) {
        this.param = JSON.parse(JSON.stringify(this.queryParam))
        this.param.pageNo = 1
        this.param.pageSize = 1000
        this.param.column = 'createTime'
        this.param.order = 'desc'
        this.param.beginDate = moment(this.param.beginDate)
          .subtract(14, 'days')
          .format('YYYY-MM-DD')

        getAction(this.url.studentFaceList, this.param).then((res) => {
          if (res.success) {
            this.picData = this.jsonArrayGroup(res.result.records)
          }
          this.picLoading = false
        })
      }
    },

    jsonArrayGroup(arr) {
      var map = {},
        dest = []
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i]
        var key = ai.createTime.substring(0, 10)
        if (!map[key]) {
          dest.push({
            name: key,
            data: [ai],
          })
          map[key] = ai
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j]
            if (dj.name == key) {
              dj.data.push(ai)
              break
            }
          }
        }
      }
      return dest
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style>
.ant-table-fixed-header .ant-table-scroll .ant-table-header {
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
  overflow: hidden !important;
  opacity: 0.9999;
  padding-right: 8px;
}
</style>
